import { useTranslation } from 'react-i18next';
import React from 'react';
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import { cardStyles } from '../../RestaurantOverviewPage/styles';
import { RemovedCardData } from './useUpcomingProductOverview';

export const RemovedProductCard: React.FC<RemovedCardData> = ({ productId, name, categoryName, recipe }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Header>
        <ProductName to={`/products/${productId}`}>{name}</ProductName>
        <Pill>{t('products.upcoming.toBeRemoved')}</Pill>
      </Header>
      <Category>{categoryName}</Category>
      <Recipe>
        {recipe.map((row) => (
          <RecipeLine key={row.ingredientId} $inactive={!row.isActive}>
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <Quantity>{row.quantity} ×</Quantity> {row.name}
          </RecipeLine>
        ))}
      </Recipe>
    </Card>
  );
};

const Card = styled.div`
  ${cardStyles}
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
  width: 240px;
  border-color: ${({ theme }) => theme.palette.error.main};
  font-size: ${({ theme }) => theme.fontSizes.sm};

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 100%;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const ProductName = styled(RouterLink)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: 700;
  line-height: 1.3;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    text-decoration: underline;
  }
`;

const Pill = styled.span`
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: ${({ theme }) => theme.fontSizes.xxs};
  font-weight: 700;
  color: ${({ theme }) => theme.palette.error.main};
  background-color: ${({ theme }) => alpha(theme.palette.error.main, 0.14)};
`;

const Category = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

const Recipe = styled.div`
  padding-top: ${({ theme }) => theme.spacing(0.5)};
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  font-size: ${({ theme }) => theme.fontSizes.xs};
`;

const RecipeLine = styled.div<{ $inactive: boolean }>`
  color: ${({ theme, $inactive }) => ($inactive ? theme.palette.error.main : theme.palette.text.primary)};
`;

const Quantity = styled.span`
  font-weight: 700;
`;
